import { Outlet, Navigate } from 'react-router';
import {useFirebaseAuth} from './context/AuthContext.js';
import { getPrj } from './constants/methods.js';

// Proyectos con trazabilidad st... desplegada; fuera de ellos se bloquea la ruta del panel a estadisticas.
const ALERT_REPORT_PROJECTS = ['pus', 'ahp', 'rep'];

const MenuInterceptor = (props) => {
  const a = useFirebaseAuth(); 
  // Antes estaba como true, pero eso permitia por defecto cualquier ruta sin case explicito se pudiera acceder
  // //aunque no tuviese el rol adecuado.
  // let go = true;
  let go = false;
  switch (props.p) {
    case 'dashboard':
    case 'pittpanel':
    case 'simulatorpanel':
    case 'usertravels':
    case 'heatmap':
      go = a?.rol?.indexOf('ADMIN') > -1 || a?.rol?.indexOf('MANAGEMENT') > -1;
      break;
    case 'alerts':
    case 'cancelled':
    case 'closed':
    case 'mapped':
    case 'watch':
      go = a?.rol?.indexOf('ADMIN') > -1 || a?.rol?.indexOf('OPERATOR') > -1;
      break;
    case 'alertstats':
      go = ALERT_REPORT_PROJECTS.indexOf(getPrj()) > -1 && (a?.rol?.indexOf('ADMIN') > -1 || a?.rol?.indexOf('MANAGEMENT') > -1);
      break;
  }

  // Si coincide devuelve 0 (true), si no coincide devuelve -1 (false)
  // console.log(go)
  // console.log(a?.rol?.indexOf('ADMIN'))
  // console.log(a?.rol?.indexOf('OPERATOR'))
  // console.log(a?.rol?.indexOf('MANAGEMENT'))
  return  go ? <Outlet /> : <Navigate to='/login' />;
}

export default MenuInterceptor
